module.exports = __webpack_public_path__ + "static/img/Sam.02c56e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/Sam.png
// module id = u8TB
// module chunks = 42